import { useState } from 'react'

import { useTranslation } from 'react-i18next'

import { Box as DarkBox, StarIcon, Tooltip, tokenVar } from '@hivewatch/dark'

interface DarkDefaultFloorIndicatorIProps {
  colorScheme: 'dark' | 'light'
}

export const DarkDefaultFloorIndicator = ({
  colorScheme,
}: DarkDefaultFloorIndicatorIProps) => {
  const { t } = useTranslation()
  const [anchorEl, setAnchorEl] = useState<HTMLDivElement | null>(null)

  // Without an explicit token the star inherits whatever colour the row sets,
  // which leaves it nearly invisible on the dark surface.
  const starColor = tokenVar(
    colorScheme === 'light'
      ? 'colors.light.icon.secondary'
      : 'colors.icon.secondary'
  )

  return (
    <DarkBox
      alignItems='center'
      data-testid='floorPlanPage_floorsPanel_defaultFloorIndicator'
      display='flex'
      onMouseEnter={(e) => setAnchorEl(e.currentTarget as HTMLDivElement)}
      onMouseLeave={() => setAnchorEl(null)}
    >
      <StarIcon color={starColor} size={16} />
      <Tooltip
        anchorEl={anchorEl}
        colorScheme={colorScheme}
        label={t('floors:default_floor_indicator')}
        placement='bottom'
      />
    </DarkBox>
  )
}
